import { render, staticRenderFns } from "./StatusCodeCard.vue?vue&type=template&id=14abbc97"
import script from "./StatusCodeCard.vue?vue&type=script&lang=js"
export * from "./StatusCodeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports